import _ from "lodash";
import React from "react";
import classnames from "classnames";

import { useForm } from "@sportal/cdk/form/Form";
import { useOutsideClick } from "@sportal/cdk/hooks";

import { getAvailableName } from "../schedules.selectors";
import { RulePopupActions } from "./rulePopupActions/RulePopupActions";
import { RulePopupHeader } from "./rulePopupHeader/RulePopupHeader";
import { RulePopupEditForm } from "./rulePopupEditForm/RulePopupEditForm";
import { RulePopupPreview } from "./rulePopupPreview/RulePopupPreview";

import "./RulePopup.scss";

export const RulePopup = ({
  setPopperElement,
  setArrowElement,
  popperStyles = {},
  attributes = {},
  togglePopup,
  selectedDays = [],
  timeStart = "01:00",
  timeEnd = "01:01",
  isEdit = false,
  useShortNotations,
  allowDelete,
  type,
  profile,
  schedules,
  onRuleChange,
  onRuleRemove,
  addSchedule,
}) => {
  const formProps = useForm({
    selectedDays,
    timeStart,
    timeEnd,
  });

  const close = () => {
    togglePopup(false);
  };
  const save = () => {
    const changes = {
      day: formProps.values.selectedDays,
      timeStart: formProps.values.timeStart,
      timeEnd: formProps.values.timeEnd,
    };
    const scheduleToSave = {
      type,
      profile,
      enabled: true,
      name: getAvailableName(type, _.map(schedules, "name")),
      categories: (schedules[0] && schedules[0].categories) || [],
      ...changes,
    };

    isEdit ? onRuleChange(changes) : addSchedule(scheduleToSave);
    close();
  };

  const classes = classnames("popup rule-popup", isEdit ? "edit" : "create");

  const outsideClickRef = useOutsideClick(close, true);
  const setReferences = (el) => {
    outsideClickRef.current = el;
    setPopperElement(el);
  };

  return (
    <div
      className={classes}
      style={popperStyles.popper}
      ref={setReferences}
      data-testid={"rule-popup"}
      {...attributes.popper}
    >
      <RulePopupHeader isEdit={isEdit} handleClose={close} />
      <RulePopupEditForm
        formProps={formProps}
        handleDaysChange={(days) => formProps.set("selectedDays", days)}
        handleTimeChange={(time, prop) => formProps.set(prop, time)}
      />
      <RulePopupPreview
        formProps={formProps}
        useShortNotations={useShortNotations}
      />
      <RulePopupActions
        isEdit={isEdit}
        allowDelete={allowDelete}
        handleClose={close}
        handleSubmit={save}
        handleRemove={onRuleRemove}
        isSubmitDisabled={
          !formProps.didFormChange() || _.isEmpty(formProps.values.selectedDays)
        }
      />
      <div
        className={"popup__arrow"}
        ref={setArrowElement}
        style={popperStyles.arrow}
      />
    </div>
  );
};
